/* eslint-disable react-hooks/rules-of-hooks */
import {
  selectCarsLoading,
  selectIsInitialCarsLoad,
} from '../redux/store/userData/cars/selectors';
import {
  selectAreasLoading,
  selectIsInitialAreasLoad,
} from '../redux/store/appData/areas/selectors';
import {
  selectClaimsLoading,
  selectIsInitialClaimsLoad,
} from '../redux/store/userData/claims/selectors';
import {
  selectCaresLoading,
  selectIsInitialCaresLoad,
} from '../redux/store/userData/cares/selectors';
import {
  selectBookingsLoading,
  selectTripLoading,
  selectIsInitialTripsLoad,
  selectIsInitialBookingsLoad,
} from '../redux/store/userData/trips/selectors';
import {
  selectReceiptsLoading,
  selectIsInitialReceiptsLoad,
} from '../redux/store/userData/receipts/selectors';
import {
  selectFuelTransactionsLoading,
  selectIsInitialFuelTransactionsLoad,
} from '../redux/store/userData/fuelTransactions/selectors';
import {
  selectUsersLoading,
  selectIsInitialUsersLoad,
} from '../redux/store/userData/users';
import {
  selectCirclesLoading,
  selectIsInitialCirclesLoad,
} from '../redux/store/userData/circles';
import {
  selectLoadingAdmins,
  selectIsInitialAdminsLoad,
} from '../redux/store/userData/admins';
import {
  selectCategoryLoading,
  selectIsInitialCategoriesLoad,
} from '../redux/store/userData/categories/selectors';
import {
  selectProfilesLoading,
  selectIsInitialProfilesLoad,
} from '../redux/store/userData/profiles';
import {
  selectPricignsLoading,
  selectIsInitialPricingsLoad,
} from '../redux/store/appData/pricings/selectors';
import { useSelector } from 'react-redux';
import {
  selectPrivacyPolicyLoading,
  selectIsInitialPrivacyPolicyLoad,
} from '../redux/store/appData/privacyPolicy';
import { ViewMode } from './viewMode';

const loadingSelectorsMap = {
  [ViewMode.VEHICLE]: selectCarsLoading,
  [ViewMode.AREA]: selectAreasLoading,
  [ViewMode.CLAIM]: selectClaimsLoading,
  [ViewMode.CARE]: selectCaresLoading,
  [ViewMode.SHARE]: selectTripLoading,
  [ViewMode.RECEIPTS]: selectReceiptsLoading,
  [ViewMode.FUEL_TRANSACTIONS]: selectFuelTransactionsLoading,
  [ViewMode.USERS]: selectUsersLoading,
  [ViewMode.CIRCLE]: selectCirclesLoading,
  [ViewMode.BOOKING]: selectBookingsLoading,
  [ViewMode.ADMINS]: selectLoadingAdmins,
  [ViewMode.CATEGORIES]: selectCategoryLoading,
  [ViewMode.PROFILE]: selectProfilesLoading,
  [ViewMode.PRICING]: selectPricignsLoading,
  [ViewMode.PRIVACY_POLICY]: selectPrivacyPolicyLoading,
};

const initialLoadSelectorsMap = {
  [ViewMode.VEHICLE]: selectIsInitialCarsLoad,
  [ViewMode.AREA]: selectIsInitialAreasLoad,
  [ViewMode.CLAIM]: selectIsInitialClaimsLoad,
  [ViewMode.CARE]: selectIsInitialCaresLoad,
  [ViewMode.SHARE]: selectIsInitialTripsLoad,
  [ViewMode.RECEIPTS]: selectIsInitialReceiptsLoad,
  [ViewMode.FUEL_TRANSACTIONS]: selectIsInitialFuelTransactionsLoad,
  [ViewMode.USERS]: selectIsInitialUsersLoad,
  [ViewMode.CIRCLE]: selectIsInitialCirclesLoad,
  [ViewMode.BOOKING]: selectIsInitialBookingsLoad,
  [ViewMode.ADMINS]: selectIsInitialAdminsLoad,
  [ViewMode.CATEGORIES]: selectIsInitialCategoriesLoad,
  [ViewMode.PROFILE]: selectIsInitialProfilesLoad,
  [ViewMode.PRICING]: selectIsInitialPricingsLoad,
  [ViewMode.PRIVACY_POLICY]: selectIsInitialPrivacyPolicyLoad,
};

export const useLoadingViewMode = (viewMode) =>
  useSelector(loadingSelectorsMap[viewMode] || (() => null));

export const useIsInitialLoad = (viewMode) =>
  useSelector(initialLoadSelectorsMap[viewMode] || (() => false));

export const useIsRefreshing = (viewMode) => {
  const loading = useSelector(loadingSelectorsMap[viewMode] || (() => false));
  const isInitialLoad = useSelector(
    initialLoadSelectorsMap[viewMode] || (() => false)
  );
  return loading && !isInitialLoad;
};
